enum ShowMode {
    Begin = 'begin',
    Middle = 'middle',
    End = 'end'
}

const pagesCalculator = (pagesLength, currentPage) => {
    let numbersOfPages = [];

    // count of visible pages from/to 3dots
    // TODO: need to finish write a behavior for middle position for widthMode === 4 | 5, etc
    const numberOfVisiblePages = 3;
    const endPointForMiddleTransition = pagesLength - numberOfVisiblePages + 1;

    // maximum pages without 3dots
    const startShow = 5;

    const pagesPosition = mode => {
        const result = [];
        const middleStartIteration = currentPage - Math.floor(numberOfVisiblePages / 2);
        const middleLimitIteration = currentPage + Math.floor(numberOfVisiblePages / 2);

        switch (mode) {
            case ShowMode.Begin:
                for (let i = 1; i <= numberOfVisiblePages; i++) {
                    result.push(i);
                }
                break;
            case ShowMode.Middle:
                for (let i = middleStartIteration; i <= middleLimitIteration; i++) {
                    result.push(i);
                }
                break;
            case ShowMode.End:
                for (let i = endPointForMiddleTransition; i <= pagesLength; i++) {
                    result.push(i);
                }
        }

        return result;
    };

    if (pagesLength >= 1 && pagesLength <= startShow) {
        for (let i = 1; i <= pagesLength; i++) {
            numbersOfPages.push(i);
        }
    } else if (currentPage < numberOfVisiblePages) {
        numbersOfPages = [...pagesPosition('begin'), '...', pagesLength];
    } else if (currentPage >= numberOfVisiblePages && currentPage <= endPointForMiddleTransition) {
        numbersOfPages = [1, '...', ...pagesPosition('middle'), '...', pagesLength];
    } else {
        numbersOfPages = [1, '...', ...pagesPosition('end')];
    }

    return numbersOfPages;
};

export { pagesCalculator };